import store from 'store';
import * as req from 'api/actions';
import _ from 'lodash';
import alert from 'react-s-alert';
import * as c from './constants';

export const login = (payload, callback) =>
  req.loginCreate(
    c.LOGIN,
    '/api/v1/authenticate',
    payload,
    ({ res }) => {
      const { data, token } = res.res;
      if (data.is_mfa_required === true) {
        sessionStorage.setItem('temporaryToken', token);
        sessionStorage.setItem('profile', JSON.stringify(data));
        if (callback) callback(data);
      }
      else {
        const { permissions, roles } = res.res;
        const profile = _.get(data, 'attributes');
        const profile_id = _.get(data, 'id');
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('profile', JSON.stringify({ ...profile, roles, profile_id }));
        sessionStorage.setItem(
          'permissions',
          JSON.stringify(_.map(permissions, 'name'))
        );
        sessionStorage.setItem(
          'permissionsList',
          JSON.stringify(permissions)
        );

        store.dispatch(req.setItem(c.AUTH, { token, isAuthenticated: true }));
        store.dispatch(req.setItem(c.USER_PROFILE, profile));
        if (callback) callback(profile);
      }
    }
  );

export const mfaLogin = (payload, callback) =>
  req.create(
    c.MFA_LOGIN,
    'api/v1/mfa_authenticate',
    payload,
    ({ res }) => {
      const { data, token, permissions, roles } = res.res;
      const profile = _.get(data, 'attributes');
      const profile_id = _.get(data, 'id');
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('profile', JSON.stringify({ ...profile, roles, profile_id }));
      sessionStorage.setItem(
        'permissions',
        JSON.stringify(_.map(permissions, 'name'))
      );

      sessionStorage.setItem(
        'permissionsList',
        JSON.stringify(permissions)
      );

      store.dispatch(req.setItem(c.AUTH, { token, isAuthenticated: true }));
      store.dispatch(req.setItem(c.USER_PROFILE, profile));
      if (callback) callback(profile);
    },
    {
      defaultMessage: 'You have successfully logged in!',
    }
  );

export const logout = callback =>
  req.setItemDelay(c.LOGOUT, {}, () => {
    localStorage.clear();
    sessionStorage.clear();
    store.dispatch(
      req.setItem(c.AUTH, { token: null, isAuthenticated: false })
    );
    if (callback) callback();
  });

export const forgotPass = (params, callback) =>
  req.create(
    c.FORGOT_PASS,
    'api/v1/administrators/forgot_password',
    params,
    res => {
      const { message } = res.res;
      alert.success(message || 'Please check your Email!');
      if (callback) callback();
    }
  );

export const verifyMobile = (params, callback) =>
  req.create(
    c.VERIFY_MOBILE,
    'api/v1/administrators/forgot_password_change',
    params,
    res => {
      const { message } = res.res;
      alert.success(message || 'You Successfully change your password!');
      if (callback) callback();
    }
  );

export const getDemoList = (payload, callback) =>
  req.list(c.GET_DEMO_LIST, 'api/v1/layout_settings/', payload, callback);

export const getDemo = (id, payload, callback) =>
  req.item(c.GET_DEMO_INFO, `api/v1/layout_settings/${id}`, payload, callback);

export const createDemo = (params, callback) =>
  req.create(c.CREATE_DEMO, 'api/v1/layout_settings', params, res => {
    const { message } = res.res;
    alert.success(message || 'You added city for demo!');
    if (callback) callback();
  });

export const updateDemo = (id, payload, callback) =>
  req.update(c.UPDATE_DEMO, `api/v1/layout_settings/${id}`, payload, callback);

export const verifyLogin = (id, payload, callback) =>
  req.update(c.VERIFY_LOGIN, `api/v1/verify_login/${id}`, payload, callback);


export const generate2fa = (payload, callback) =>
  req.create(
    c.GENERATE_2FA,
    'api/v1/mfa_authenticate/google_2fa/generate',
    payload,
    ({ res }) => {
      const data = res.res;
      if (callback) callback({ data });
    }
  );

export const email2fa = (payload, callback) =>
  req.create(
    c.EMAIL_2FA,
    'api/v1/mfa_authenticate/send_otp',
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Please check your Email!');
      if (callback) callback();
    }
  );

export const enable2fa = (payload, callback) =>
  req.create(
    c.ENABLE_2FA,
    'api/v1/mfa_authenticate/google_2fa/enable',
    payload,
    ({ res }) => {
      const { data, token, permissions } = res.res;
      const profile = _.get(data, 'attributes');
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('profile', JSON.stringify(profile));
      sessionStorage.setItem(
        'permissions',
        JSON.stringify(_.map(permissions, 'name'))
      );

      store.dispatch(req.setItem(c.AUTH, { token, isAuthenticated: true }));
      store.dispatch(req.setItem(c.USER_PROFILE, profile));
      if (callback) callback(profile);
    },
    {
      defaultMessage: 'You have successfully logged in!',
    }
  );

export const disable2fa = (payload, callback) =>
  req.create(
    c.DISABLE_2FA,
    'api/v1/administrators/disable2fa',
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'You have successfully disabled your account.');
      if (callback) callback();
    }
  );

export const resendOtp = (payload, callback) =>
  req.create(
    c.RESEND_OTP,
    'api/v1/mfa_authenticate/send_otp',
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Please check your Email!');
      if (callback) callback();
    }
  );

export const updateMfaType = (payload, callback) =>
  req.update(
    c.UPDATE_MFA_TYPE,
    'api/v1/mfa_authenticate/preferred_mfa',
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );